import { render, staticRenderFns } from "./searchHeader.vue?vue&type=template&id=3d65fe86&scoped=true"
import script from "./searchHeader.vue?vue&type=script&lang=ts"
export * from "./searchHeader.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./searchHeader.vue?vue&type=style&index=0&id=3d65fe86&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3d65fe86",
  "c5928c06"
  
)

export default component.exports